/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocNavigationResponse } from '../models/DocNavigationResponse';
import type { DocResponse } from '../models/DocResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocsService {
    /**
     * Get a portal documentation page
     * @param path Doc page path, e.g. end-user/dashboard
     * @param userSession
     * @returns DocResponse Successful Response
     * @throws ApiError
     */
    public static getDoc(
        path: string,
        userSession?: (string | null),
    ): CancelablePromise<DocResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/docs/content',
            cookies: {
                'user_session': userSession,
            },
            query: {
                'path': path,
            },
            errors: {
                404: `Documentation not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get the portal documentation navigation
     * @param userSession
     * @returns DocNavigationResponse Successful Response
     * @throws ApiError
     */
    public static getDocNavigation(
        userSession?: (string | null),
    ): CancelablePromise<DocNavigationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/docs/navigation',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                404: `Documentation navigation not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get an admin documentation page
     * @param path Admin doc page path, e.g. admin/auth/policies
     * @param userSession
     * @returns DocResponse Successful Response
     * @throws ApiError
     */
    public static getAdminDoc(
        path: string,
        userSession?: (string | null),
    ): CancelablePromise<DocResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/docs/admin/content',
            cookies: {
                'user_session': userSession,
            },
            query: {
                'path': path,
            },
            errors: {
                404: `Documentation not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get the admin documentation navigation
     * @param userSession
     * @returns DocNavigationResponse Successful Response
     * @throws ApiError
     */
    public static getAdminDocNavigation(
        userSession?: (string | null),
    ): CancelablePromise<DocNavigationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/docs/admin/navigation',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                404: `Documentation navigation not found`,
                422: `Validation Error`,
            },
        });
    }
}
